<template>
  <div class="overflow-y-auto">
    <group-node
        v-for="node in orgList"
        :key="node.id"
        ref="orgNodeRefs"
        :ref-in-for="true"
        :node="node"
        :is-first-node="true"
        :selected="selected"
        @select="handleSelect"
    />
  </div>
</template>
<script>
import GroupNode from "@/pages/Member/components/MemberManage/GroupNode.vue";
export default {
  name: "GroupTree",
  components: {GroupNode},
  props: ["orgList", "isShowDelete"],
  data() {
    return {
      searchName: "",
      findNode: [],
      treeData: null,
      selected: null
    }
  },
  watch: {
    isShowDelete(value) {
      if (value) {
        this.selected = null;
      }
    }
  },
  methods: {
    handleSelect(node) {
      this.selected = node;
      this.$emit("select", this.selected);
    },
    // 전체 OrgNode 중 하나라도 닫혀있으면 true
    hasAnyCollapsed() {
      return this.$refs.orgNodeRefs?.some(ref => !ref.expanded);
    },
    expandAll() {
      this.$refs.orgNodeRefs?.forEach(ref => {
        ref.expandAll?.();
      });
    },
    collapseAll() {
      this.$refs.orgNodeRefs?.forEach(ref => {
        ref.collapseAll?.();
      });
    },
  }
}
</script>